import getCheckedBoxValuesByName from './helpers';
import $ from 'jquery';
// eslint-disable-next-line no-unused-vars
import select2 from 'select2';

export default {
  init() {
    $("#swish_payout_all").on('change', function() {
        $(".swish_payout:enabled").prop('checked', this.checked);
    })

    $("input[type=radio][name=filter_payouts]").on('change', function() {
        let filter = $(this).val();
        $("input[name=filter]").val(filter);
        $("#payouts-table tr").filter(function() {
            let visible = $(this).data("filter") == filter;

            if (filter == "all" || $(this).has('th').length) {
                $(this).toggle(true)
                $(this).find("td > input[type=checkbox][data-manual-payable=1]").first().prop('disabled', false);
            } else {
                $(this).toggle(visible)
                $(this).find("td > input[type=checkbox][data-manual-payable=1]").first().prop('disabled', !visible);
            }
        })
    })

    $('input[type=radio][name=payment_method]').on('change', (e) => {
        const choosenPayment = $('#payment-options #' + e.target.id + '-wrapper');
        choosenPayment.show();
        choosenPayment.siblings().hide();
    });

    const validateSSN = (twelveDigitSSN) => {
      let tenDigitSSN = twelveDigitSSN.substring(2);
      let tenDigitSSNSeparated = tenDigitSSN.split("");
      let tenDigitSSNCheckDigit = parseInt(tenDigitSSNSeparated.pop());
      
      let checkSum = 0;
      var checkDigit = 0;
      
      tenDigitSSNSeparated.forEach((digit, index) => {
        let validationDigit = (index % 2 ) == 0 ? 2 : 1;
        
        let checkSums = (parseInt(digit) * validationDigit).toString().split("");
        
        checkSums.forEach(sum => {
          checkSum += parseInt(sum);
        });
      });
      
      checkDigit = (checkSum % 10) > 0 ? (10 - (checkSum % 10)) : 0;
      
      return tenDigitSSNCheckDigit === checkDigit
  }
      
    const validatePhoneNumber = (phoneNumber) => {
        return phoneNumber.startsWith("07") && phoneNumber.split("").length === 10;
    }

    let targetSelector = "";
    if (document.getElementById('admin-swish-payouts')) {
        targetSelector = 'admin-swish-payouts';
    } else if (document.getElementById('influencer-payout-settings')) {
        targetSelector = 'influencer-payout-settings';
    } else {
        return;
    }

    const formElement = document.getElementById(targetSelector);

    const toggleSaveMode = (e) => {
      e.preventDefault();
      const parElm = e.target.parentNode;
      const childrenToToggle = parElm.querySelectorAll('.js-toggle-hidden');

      const mode = parElm.getAttribute('data');
      if (mode === 'gender' && window.innerWidth > 1280) {
        parElm.classList.remove('xl:w-1/2');
      }
      childrenToToggle.forEach(el => {
        el.classList.toggle('hidden');
      });
    }

    const checkFieldErrors = () => {
        var fieldsValid = true;

        if ($("#payout_payee_first_name").val() == "") {
            $("#payout_payee_first_name").removeClass("border-grey-darkest").addClass("border-red-700")
            $("#payout_payee_first_name").after('<p id="payout_payee_first_name_error" class="text-red-700">Detta fältet är obligatoriskt</p>')
            fieldsValid = false;
        }

        if ($("#payout_payee_last_name").val() == "") {
            $("#payout_payee_last_name").removeClass("border-grey-darkest").addClass("border-red-700")
            $("#payout_payee_last_name").after('<p id="payout_payee_last_name_error" class="text-red-700">Detta fältet är obligatoriskt</p>')
            fieldsValid = false;
        }

        if ($("#payout_payee_ssn").val() == "") {
            $("#payout_payee_ssn").removeClass("border-grey-darkest").addClass("border-red-700")
            $("#payout_payee_ssn").after('<p id="payout_payee_ssn_error" class="text-red-700">Detta fältet är obligatoriskt</p>')
            fieldsValid = false;
        } else if (!validateSSN($("#payout_payee_ssn").val())) {
            $("#payout_payee_ssn").removeClass("border-grey-darkest").addClass("border-red-700")
            $("#payout_payee_ssn").after('<p id="payout_payee_ssn_error" class="text-red-700">Felaktigt personnummer</p>')
            fieldsValid = false;
        }

        if ($("#payout_payee_phone_number").val() == "") {
            $("#payout_payee_phone_number").removeClass("border-grey-darkest").addClass("border-red-700")
            $("#payout_payee_phone_number").after('<p id="payout_payee_phone_number_error" class="text-red-700">Detta fältet är obligatoriskt</p>')
            fieldsValid = false;
        } else if (!validatePhoneNumber($("#payout_payee_phone_number").val())) {
            $("#payout_payee_phone_number").removeClass("border-grey-darkest").addClass("border-red-700")
            $("#payout_payee_phone_number").after('<p id="payout_payee_phone_number_error" class="text-red-700">Felaktigt telefonnummer</p>')
            fieldsValid = false;
        }

        if ($("#payout_amount").val() == "") {
            $("#payout_amount").removeClass("border-grey-darkest").addClass("border-red-700")
            $("#payout_amount").after('<p id="payout_amount_error" class="text-red-700">Detta fältet är obligatoriskt</p>')
            fieldsValid = false;
        }

        if ($("#payout_campaign").val() == "") {
            $("#payout_campaign").removeClass("border-grey-darkest").addClass("border-red-700")
            $("#payout_campaign").after('<p id="payout_campaign_error" class="text-red-700">Detta fältet är obligatoriskt</p>')
            fieldsValid = false;
        }

        return fieldsValid;
    }

    const resetFieldErrors = () => {
        $("#payout_payee_first_name").removeClass("border-red-700").addClass("border-grey-darkest")
        $("#payout_payee_first_name_error").remove()
        $("#payout_payee_last_name").removeClass("border-red-700").addClass("border-grey-darkest")
        $("#payout_payee_last_name_error").remove()
        $("#payout_payee_ssn").removeClass("border-red-700").addClass("border-grey-darkest")
        $("#payout_payee_ssn_error").remove()
        $("#payout_payee_phone_number").removeClass("border-red-700").addClass("border-grey-darkest")
        $("#payout_payee_phone_number_error").remove()
        $("#payout_amount").removeClass("border-red-700").addClass("border-grey-darkest")
        $("#payout_amount_error").remove()
        $("#payout_campaign").removeClass("border-red-700").addClass("border-grey-darkest")
        $("#payout_campaign_error").remove()
    }
    
    const addSwishManualPayout = (e) => {
        resetFieldErrors();

        var fieldsOk = checkFieldErrors();

        let firstName = $("#payout_payee_first_name");
        let lastName = $("#payout_payee_last_name");
        let ssn = $("#payout_payee_ssn");
        let phoneNumber = $("#payout_payee_phone_number");
        let amount = $("#payout_amount");
        let campaign = $("#payout_campaign");

        if (fieldsOk) {
            $(e.target).prop('disabled', true);
            $("#payout_add_spinner").toggleClass("hidden");

            $.post(
                window.ajax_object.ajaxurl, 
                {
                    "action": "add_manual_payout",
                    "first_name": firstName.val(),
                    "last_name": lastName.val(),
                    "ssn": ssn.val(),
                    "phone": phoneNumber.val(),
                    "campaign": campaign.val(),
                    "amount": amount.val()
                }, 
                function(data) {
                    if (!data.success) {
                        alert(data.message);
                    } else {
                        $("#payouts-table tr:first").after(
                            '<tr data-filter="unpaid">' +
                                '<td class="text-left pr-2"><input type="checkbox" name="payout[]" class="swish_payout" value="' + data.payment_id + '" enabled /></td>' +
                                '<td class="text-left pr-4 sm:pr-8 md:pr-10">' + firstName.val() + ' ' + lastName.val() + '</td>' +
                                '<td class="text-left pr-4 sm:pr-8 md:pr-10">' + ssn.val() + '</td>' +
                                '<td class="text-left pr-4 sm:pr-8 md:pr-10">' + phoneNumber.val() + '</td>' +
                                '<td class="text-left pr-4 sm:pr-8 md:pr-10">' + $("#payout_campaign option:selected").text() + '</td>' +
                                '<td class="text-left pr-4 sm:pr-8 md:pr-10">' + amount.val() + 'kr</td>' +
                                '<td class="text-left pr-4 sm:pr-8 md:pr-10">Obetald</td>' +
                                '<td class="text-left pr-4 sm:pr-8 md:pr-10">N/A</td>' +
                            '</tr>'
                        );
    
                        const body = $(document.querySelector('body'));
                        const modal = $(e.target).closest(".modal")
                        modal.toggleClass('opacity-0');
                        modal.toggleClass('pointer-events-none');
                        body.toggleClass('modal-active');
    
                        firstName.val("");
                        lastName.val("");
                        ssn.val("");
                        phoneNumber.val("");
                        amount.val("");

                        $("#payout_add_spinner").toggleClass("hidden");
                        $(e.target).prop('disabled', false);
                    }
                }
            );
        }
    }

    const swishPayoutSelected = () => {
        let payoutIds = [];
        let selectedPayouts = $("#payouts-table tr").find("td > input[type=checkbox]:checked");

        selectedPayouts.each((index) => {
            payoutIds.push($(selectedPayouts[index]).val());
        });

        $.post(
            window.ajax_object.ajaxurl, 
            {
                "action": "perform_manual_payout",
                "payout_ids": payoutIds
            }, 
            function(data) {
                if (data.success) {
                  window.location.reload();
                }
            }
        );
    }

    const savePayoutSettings = (e) => {
        $("#swish_ssn").removeClass("border-red-700").addClass("border-grey-darkest")
        $("#swish_ssn_error").remove()
        $("#swish_phone_number").removeClass("border-red-700").addClass("border-grey-darkest")
        $("#swish_phone_number_error").remove()

        const message = document.getElementById('form-save');
        message.classList.remove('hidden');

        const parElm = e.target.parentNode;
        const mode = parElm.getAttribute('data');

        if (mode) {
            if ('paypal_identifier' === mode) {
                const inputElm = document.querySelector('input[name="paypal_identifier"]');
                const targetElm = document.getElementById('paypal_identifier');
                if (inputElm && targetElm) {
                    targetElm.innerHTML = inputElm.value;
                }
            }
        }

        const childrenToToggle = parElm.querySelectorAll('.js-toggle-hidden');

        let FD = new FormData(formElement);

        FD.append('action', 'influencer_payout_settings')

        var fieldsValid = true;

        if (FD.get('payment_method') == "swish") {

            if (!validateSSN(FD.get('swish_ssn'))) {
                $("#swish_ssn").removeClass("border-grey-darkest").addClass("border-red-700")
                $("#swish_ssn").after('<p id="swish_ssn_error" class="text-red-700">Felaktigt personnummer</p>')
                fieldsValid = false;
            }

            if (!validatePhoneNumber(FD.get('swish_phone_number'))) {
                $("#swish_phone_number").removeClass("border-grey-darkest").addClass("border-red-700")
                $("#swish_phone_number").after('<p id="swish_phone_number_error" class="text-red-700">Felaktigt telefonnummer</p>')
                fieldsValid = false;
            }

        }

        if (fieldsValid) {
            let request = new XMLHttpRequest();
            request.open('POST', window.ajax_object.ajaxurl, true);
            request.onload = function () {
              if (this.status >= 200 && this.status < 400) {
                if (request.response) {
                  const data = JSON.parse(request.response);
                  if (!data.success) {
                    alert(data.message);
                  } else {
                    setTimeout(function () {
                      message.classList.add('hidden');
                    }, 750);
      
                    childrenToToggle.forEach(el => {
                      el.classList.toggle('hidden');
                    });
                  }
                }
              }
            };
            request.onerror = function (err) {
              console.log(err);
            };
            request.send(FD);
        } else {
            setTimeout(function () {
                message.classList.add('hidden');
            }, 750);
        }
    }

    const saveData = (e) => {
      const message = document.getElementById('form-save');
      message.classList.remove('hidden');

      const parElm = e.target.parentNode;
      const mode = parElm.getAttribute('data');

      if (mode) {
        if ('interests' === mode) {
          const targetElm = document.getElementById('interests');
          targetElm.innerHTML = "";
          const interestList = JSON.parse(window.interests_full_labels);

          const newInterests = $('[name="interests[]"]').select2('data');
          if (newInterests) {
            newInterests.forEach(i => {
              let child = document.createElement('div');
              child.className = window.interest_css;
              child.innerHTML = interestList[i.id];
              targetElm.appendChild(child);
            });
          }
        } else if ('gender' === mode) {
          const newGender = getCheckedBoxValuesByName('gender');
          if (newGender) {
            const targetElm = document.getElementById('gender');
            targetElm.innerHTML = newGender[0];
            if (window.innerWidth > 1280) {
              parElm.classList.add('xl:w-1/2');
            }
          }
        } else if ('paypal_identifier' === mode) {
          const inputElm = document.querySelector('input[name="paypal_identifier"]');
          const targetElm = document.getElementById('paypal_identifier');
          if (inputElm && targetElm) {
            targetElm.innerHTML = inputElm.value;
          }
        } else if ('region' === mode) {
          const inputElm = document.querySelector('[name="' + mode + '"]:checked');
          const targetElm = document.getElementById(mode);
          if (inputElm && targetElm) {
            targetElm.innerHTML = inputElm.dataset.label;
          }
        } else if ('social_media' !== mode) {
          const inputElm = document.querySelector('[name="' + mode + '"]');
          const targetElm = document.getElementById(mode);
          if (inputElm && targetElm) {
            targetElm.innerHTML = inputElm.value;
          }
        }
      }

      // Prevent browser from autofill hidden password fields
      var passwordElm = document.querySelector('input[name="password"]');
      window.passwordElm = passwordElm;
      var passwordConfirmElm = document.querySelector('input[name="confirm_password"]');
      if(passwordElm !== null && passwordElm.clientHeight === 0 && passwordConfirmElm.clientHeight === 0){
        passwordConfirmElm.value = '';
        passwordElm.value = '';
      }

      const childrenToToggle = parElm.querySelectorAll('.js-toggle-hidden');

      let FD = new FormData(formElement);

      if ('influencer-profile' === targetSelector) {
        FD.append('action', 'influencer_profile');
      } else if ('influencer-settings' === targetSelector) {
        FD.append('action', 'influencer_settings');
      } else if ('company-profile' === targetSelector) {
        FD.append('action', 'company_profile');
      } else if ('company-settings' === targetSelector) {
        FD.append('action', 'company_settings');
      }

      if (document.querySelector('input[type=file]')) {
        const files = document.querySelector('input[type=file]').files;
        if (files && files[0]) {
          FD.append("file", files[0]);
        }
      }
      let request = new XMLHttpRequest();
      request.open('POST', window.ajax_object.ajaxurl, true);
      request.onload = function () {
        if (this.status >= 200 && this.status < 400) {
          if (request.response) {
            const data = JSON.parse(request.response);
            if (data.error) {
              alert(data.error_message);
            } else {
              setTimeout(function () {
                message.classList.add('hidden');
              }, 750);
              if (mode === 'social_media' && data && data.social_media) {
                window.social_media = data.social_media;
                const parentTable = document.querySelector('.js-social-media-tbody');
                parentTable.innerHTML = '';

                data.social_media.forEach(sm => {
                  let img_source = "";
                  if (sm.platform.toLowerCase() === 'instagram') {
                    img_source = window.instagram_img;
                  } else if (sm.platform.toLowerCase() === 'youtube') {
                    img_source = window.youtube_img;
                  } else if (sm.platform.toLowerCase() === 'facebook') {
                    img_source = window.facebook_img;
                  } else {
                    img_source = window.blog_img;
                  }

                  parentTable.innerHTML += '<tr><td class="pr-6">' +
                    '<img class="w-5 h-auto" src="' + img_source + '"></img>' +
                    '</td><td class="pr-6">' +
                    '<a class="text-black" href="' + sm.url + '">' + sm.platform + '</a>'
                    + '</td>' + '<td class="pr-6">' + sm.followers + '</td>' + '</tr>';
                });
              }

              childrenToToggle.forEach(el => {
                el.classList.toggle('hidden');
              });
            }
          }
        }
      };
      request.onerror = function (err) {
        console.log(err);
      };
      request.send(FD);
    }

    if (formElement) {
        $("#payout_add").on('click', addSwishManualPayout);
        $("#swish_perform_payout").on('click', swishPayoutSelected);

        const change_buttons = document.querySelectorAll('.js-toggle-input');
        change_buttons.forEach(btn => {
          btn.addEventListener('click', toggleSaveMode);
        });

        const save_buttons = document.querySelectorAll('.save-payout-settings');
        save_buttons.forEach(btn => {
            btn.addEventListener('click', savePayoutSettings);
        });

        formElement.addEventListener("submit", function (e) {
          if (e.submitter.id !== "swish_export") {
            e.preventDefault();
          }
        });
    }

    $('.js-save-invoice').on('click', (e) => {
      $('.invoice-error').removeClass('inline-block').addClass('hidden');
      const input_fields = $(e.target).siblings('input');

      const errors = [];
      input_fields.each(input => {
        if ( input_fields[input].value === '' ) {
          errors.push(input_fields[input].name);
        }
      });

      // Check if payment option has been selected
      if ( ! $( 'input[name=payment_option]:checked' ).val() ) {
        errors.push('payment_option');
      }

      if( 'iban' === $( 'input[name=payment_option]:checked' ).val() && $('input[name="bank_iban_name"]').val().trim().length < 8){
        errors.push('bank_iban_name');
      }
      
      if (errors.length > 0) {  
        errors.forEach(element => {
          $('.' + element + '-error').removeClass('hidden').addClass('inline-block');
        });
      } else {
        saveData(e);
      }
    });

    $('input[type=radio][name=payment_option]').on('change', (e) => {
      const paymentOption = e.target.value;
      $('.payment-option-toggle').addClass('hidden');
      if(paymentOption === 'iban'){
        $('.payment-option-iban').removeClass('hidden');
      } else if (paymentOption === 'bankgiro' || paymentOption === 'postgiro') {
        $('.payment-option-other').removeClass('hidden');
      } else if (paymentOption === 'account') {
        $('.payment-option-accountnumber').removeClass('hidden');
      }
    
    });
  },
  finalize() {
    if ($('.select2').length) {
      $('.select2').select2({
        multiple: false
      });
    }
  },
};
